<app-header (onNeedHelp)="goToHelp()"></app-header>

<router-outlet></router-outlet>

<div #help>
  <app-help></app-help>
</div>

<app-footer></app-footer>
